<template>
  <abstract-achievements-overview :achievement-type="'certificate'">
  </abstract-achievements-overview>
</template>
<script>
import AbstractAchievementsOverview from './abstract-achievements-overview.vue';

export default {
  components: { AbstractAchievementsOverview },
};
</script>
